import React, { useContext, useEffect, useState } from 'react'
import { TableBody, TableCell } from '@material-ui/core'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import Loader from '../../components/Loader'
import CustomPagination from '../../components/CustomPagination'
import { SortIcon } from '../../components/CustomComponents/CustomFilterIcon'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'

import { formatDate, formatNumber, isSelected } from '../../shared/constants'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { usePrimarySales } from '../../hooks/Sales/usePrimarySales'
import { UserContext } from '../../context api/UserContext'
import { NoDataFound } from '../../components/NoDataFound'
import ListDialog from '../../components/Dialog/ListDialog'
import Status from '../../components/Status'
import moment from 'moment'

export default function PrimarySales() {
  const [open, setOpen] = React.useState(false)
  const history = useHistory()
  const [detailDialog, setDetailDialog] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const handleDeleteOpen = () => setDeleteDialog(true)
  const handleDeleteClose = () => setDeleteDialog(false)
  const [editDialog, setEditDialog] = React.useState(false)
  const handleEditOpen = () => setEditDialog(true)
  const handleEditClose = () => {
    setEditDialog(false)
    setPrimarySale('')
  }

  const [openPopup, setOpenPopup] = React.useState(false)
  const [listPopup, setListPopup] = React.useState(false)

  const [selected, setSelected] = React.useState([])
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  //const { getCsvPdfData, pdfCsvData } = useDashBoard()
  const [searchQuery, setSearchQuery] = React.useState('')
  const [file, setFile] = React.useState('')
  const { getAllPrimarySales, deletePrimarySales, deleteManyPrimarySales, BulkUpload, loading, paginate, downloadLoading, pdfCsvData, getPdfCsvData } = usePrimarySales()
  const user = useContext(UserContext)
  const { primarySales } = useContext(FeatureContext)
  const [page, setPage] = React.useState(1)
  const [primarySale, setPrimarySale] = React.useState(1)

  const startDate = moment().startOf('quarter')
  // startDate.setDate(1)
  // startDate.setHours(0, 0, 0)
  // startDate.setMonth(1)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())

  const [filterParams, setFilterParams] = useState({ storeName: 1, firstName: null })

  let tempPrimarySales = []

  const tempheaders = [
    { label: 'saleType', key: 'saleType' },
    { label: 'storeCode', key: 'store' },
    { label: 'quantity', key: 'quantity' },
    { label: 'invoiceDate', key: 'invoiceDate' },
    { label: 'sku', key: 'product' },
    { label: 'invoiceNumber', key: 'invoiceNumber' },
    { label: 'orderNumber', key: 'orderNumber' },
    { label: 'amount', key: 'amount' },
    // { label: 'targetType', key: 'targetType' },
    // { label: 'schemCode', key: 'schemeCode' },
    // { label: 'duration', key: 'duration' },
  ]

  const tempHeaderValue = [
    // { invoiceDate: `${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}` },
  ]

  const noOfPages = paginate.totalPage

  const handleChange = (event, value) => {
    setPage(value)
  }
  useEffect(() => {
    getAllPrimarySales({ from, to, ...filterParams, searchQuery, page, limit: 70 })
  }, [from, to, searchQuery, filterParams, page])

  useEffect(() => {
    getPdfCsvData({ from, to })
  }, [from, to])

  const handleUploadFile = () => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('sheetName', 'sales')
    BulkUpload(formData)
    setFile('')
  }

  return (
    <Layout
      heading="Manage Primary Sales"
      handleOpenDialog={handleOpen}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      setFile={setFile}
      bulkUpload={handleUploadFile}
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      openDialog={open}
      setOpenDialog={setOpen}
      // url={ROUTES.ADD_PRIMARY_SALES}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      // editUrl={`/edit-primary-sales/${selected.length && selected[0]._id}`}
      uploadedfile={file}
      setUploadedFile={setFile}
      tempHeaderData={tempHeaderValue}
      filename="primary_sales"
      sampleName="sample_primary_sales"
      tempHeaders={tempheaders}
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      downloadLoading={downloadLoading}
    >
      {primarySale.product && (
        <ListDialog array={primarySale && primarySale.product} handleClose={() => setListPopup(false)} open={listPopup} heading={'Products'} name={`productId`} name2={`name`} field2={'sku'} />
      )}
      <CustomTable>
        <CustomTableHeading
          filterIcons={{
            Employee: <SortIcon onClick={() => setFilterParams({ ...filterParams, storeName: '', firstName: filterParams.firstName === 1 ? -1 : 1 })} value={filterParams.firstName} />,
            Store: <SortIcon onClick={() => setFilterParams({ ...filterParams, firstName: '', storeName: filterParams.storeName === 1 ? -1 : 1 })} value={filterParams.storeName} />,
          }}
          heading={[
            // <Checkbox
            //   indeterminate={selected.length > 0 && selected.length < primarySales.length}
            //   checked={primarySales.length > 0 && selected.length === primarySales.length}
            //   onClick={(event) => handleSelectAllClick(event, primarySales, setSelected)}
            // />,
            // 'sales type',
            // 'from sales',
            'Employee',
            'Employee Code',
            'Store',
            'Store Code',
            'Products',
            // 'SKU Code',
            'invoice Number',
            'Invoice date',
            // 'target type',
            // 'billing Price',
            'Amount',
            'Type',
            // 'info',
          ]}
        />
        <TableBody>
          {!loading &&
            primarySales.length > 0 &&
            primarySales.map((item, index) => {
              const isItemSelected = isSelected(item, selected)

              return (
                <CustomTableRow key={index}>
                  {/* <TableCell align="center">{<Avatar src={item.productImages[0]} />}</TableCell> */}

                  {/* <TableCell align="center">
                    <Checkbox
                      checked={isItemSelected}
                      onClick={() => handleSelectedItem(item, selected, setSelected)}
                    />
                  </TableCell> */}
                  {/* <TableCell>{item.saleType}</TableCell> */}
                  <TableCell> {item.employee && item.employee.firstName + ' ' + item.employee.lastName} </TableCell>
                  <TableCell> {item.employee && item.employee.employeeCode} </TableCell>
                  <TableCell>{item.store && item.store.name}</TableCell>
                  <TableCell>{item.store && item.store.storeCode}</TableCell>
                  <TableCell
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={() => {
                      setListPopup(true)
                      setPrimarySale(item)
                    }}
                  >
                    {item.product && item.product.length}
                  </TableCell>

                  <TableCell>{item.invoiceNumber}</TableCell>
                  <TableCell>{formatDate(item.invoiceDate)}</TableCell>
                  <TableCell>{formatNumber(Math.ceil(item.amount))}</TableCell>
                  <TableCell>{<Status status={item.type} />}</TableCell>
                  {/* <TableCell>
                    <AiOutlineInfoCircle style={{ width: '20px', height: '20px', cursor: 'pointer' }} onClick={() => history.push(`/view-primary-sales/${item._id}`)} />
                  </TableCell> */}
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && !primarySales.length && <NoDataFound />}

      {/* DELETE CATEGORy */}
      {/* <ConfirmDialog
        open={deleteDialog}
        handleClose={handleDeleteClose}
        // name={category.categoryName}
        handleSubmit={() => deletePrimarySales({ primarySalesId: primarySale._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyPrimarySales({ primarySalesId: multipleId }, setSelected)}
      /> */}

      {primarySales.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
    </Layout>
  )
}
